module.exports = __webpack_public_path__ + "img/sup_deposit_mtpay1.94e54ddd.jpg";